module.exports = __webpack_public_path__ + "img/tssz_banner.720f521b.png";